### global require, ga, _hmt ###
require 'plugins/pure/pure-min.css'
require 'plugins/icomoon/style.css'
require 'plugins/flexslider/flexslider.css'
require 'plugins/slick-carousel/slick/slick.css'
require 'plugins/sweetalert/lib/sweet-alert.css'
require 'plugins/swiper/dist/css/swiper.min.css'
require 'styles/common/util.scss'
require 'styles/common/common.scss'
require 'styles/common/baoming.scss'
require 'styles/pages/dmfx.scss'

require 'script!jquery'
require 'script!affix'
require 'script!plugins/scrollspy.js'
require '../common/city.coffee'
require '../common/footer.coffee'

# 报价部分js
$ ->
  if $('#baojia').length > 0
    $form = $('#baojia')
    $area = $form.find '[name="area"]'
    $truename = $form.find '[name="truename"]'
    $mobile = $form.find '[name="mobile"]'
    # 表单验证
    $form.validate
      errorPlacement: (error, element)->
        swal {
          title: error[0].innerHTML
          allowOutsideClick: false
          confirmButtonColor: '#08b3ae',
        }
      submitHandler: (form)->
        phoneNumber=form.elements.mobile.value.trim()
        userId="MOBI#{phoneNumber}"

        $(form).ajaxSubmit {
          dataType: 'json'
          data: {
            rnd: parseInt(Math.random()*1e7,10)+(new Date()).getTime()
          }
          error: ->
            swal {
              title: '对不起，出错了，请稍后重试！'
              allowOutsideClick: true
            }
          success: (res)->
            if res.msg?[0]?.type is 'success'
              swal({
                customClass: 'alert-success',
                title: '您已经报价成功',
                text: '稍后家装顾问会回电给您。请注意接听来电！',
                confirmButtonText: '返  回',
                confirmButtonColor: '#08b3ae',
                allowOutsideClick: true,
                html: true,
                timer:1000000
              })
            if res.msg[0].type is 'error'
              swal {
                title: res.msg[0].info
                allowOutsideClick: true
              }
              return false
        }
        return false

    $mobile.rules 'add',
      required: true
      mobileNum: true
      messages:
        required: '请输入11位手机号码'
        mobileNum: '请输入正确的手机号'

    $truename.rules 'add',
      required: true
      messages:
        required: '输入您的姓名'

    $area.rules 'add',
      required: true
      messages:
        required: '输入翻新面积'







/** WEBPACK FOOTER **
 ** /data/jenkins/workspace/fanzhuanjia-pc/wwwroot/static/~/coffeelint-loader!./dmfx.coffee
 **/